webpackJsonp([1],{

/***/ 184:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_about__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_about___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_about__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_belief__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_belief___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_belief__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_team__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_team___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_team__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_news__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_news___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_news__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_portfolio__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_portfolio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_portfolio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_contact__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_contact__);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Index',
    component: __WEBPACK_IMPORTED_MODULE_2__components_index___default.a
  }, {
    path: '/belief',
    name: 'Belief',
    component: __WEBPACK_IMPORTED_MODULE_4__components_belief___default.a
  }, {
    path: '/team',
    name: 'Team',
    component: __WEBPACK_IMPORTED_MODULE_5__components_team___default.a
  }, {
    path: '/news',
    name: 'News',
    component: __WEBPACK_IMPORTED_MODULE_6__components_news___default.a
  }, {
    path: '/contact',
    name: 'Contact',
    component: __WEBPACK_IMPORTED_MODULE_8__components_contact___default.a
  }, {
    path: '/portfolio',
    name: 'Portfolio',
    component: __WEBPACK_IMPORTED_MODULE_7__components_portfolio___default.a
  }, {
    path: '/about',
    name: 'About',
    component: __WEBPACK_IMPORTED_MODULE_3__components_about___default.a
  }]
}));

/***/ }),

/***/ 186:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(464)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(213),
  /* template */
  __webpack_require__(509),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 213:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var App = {
  name: 'app'
};
/* harmony default export */ __webpack_exports__["default"] = (App);

/***/ }),

/***/ 214:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__footer__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixin_fanpage_js__ = __webpack_require__(36);





var About = {
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixin_fanpage_js__["a" /* default */]],
  props: [],
  data: function data() {
    return {
      aboutList: [],
      detail: "",
      current: 0,
      langs: {
        en: {
          aboutTItle1: "About BAI",
          aboutDetail1: "Founded in January 2008, Bertelsmann Asia Investments has invested in more than 200 portfolio companies including 16 IPOs and 40+ unicorns. Bertelsmann Asia Investments focuses on sectors including Urbanization and Retail, Finance, China Based Global Company, Social/ Media/ Content and Tech & Infrastructure. As an evergreen fund, The firm accompanies portfolios’ growth with a long-term and strategic vision. Bertelsmann Asia Investments also has access to Bertelsmann’s vast resources and global channels to facilitate the expansion plans of startups.",
          aboutTItle2: "About Betafund",
          aboutDetail2: "In October 2014, BAI set up a dedicated fund, BetaFund, to promote business ideas at the very early \u201Cangel\u201D stage, focusing on early-stage companies with excellent performance in mobility, social networking, intelligent hardware, games, education, enterprise services and contents.\nBetaFund will provide capital support and professional services of every operational stage for startups seeking angel-stage investments, to create a closed-loop investment, while synergizing with Bertelsmann\u2019s business units by facilitating close partnerships. Up till now, most of the companies under Betafund\u2019s portfolio have been through next round of investment and have benefited from BAI\u2019s continuous support.",
          aboutTItle3: "About Bertelsmann",
          aboutDetail3: "Bertelsmann is a media, services and education company that operates in about 50 countries around the world. It includes the broadcaster RTL Group, the trade book publisher Penguin Random House, the magazine publisher Gruner + Jahr, the music company BMG, the service provider Arvato, the Bertelsmann Printing Group, the Bertelsmann Education Group and Bertelsmann Investments, an international network of funds. The company has 126,000 employees and generated revenues of €18.0 billion in the 2019 financial year. Bertelsmann stands for creativity and entrepreneurship. This combination promotes first-class media content and innovative service solutions that inspire customers around the world. Bertelsmann aspires to achieve climate neutrality by 2030."
        },
        zh: {
          aboutTItle1: "关于贝塔斯曼亚洲投资基金",
          aboutDetail1: "贝塔斯曼亚洲投资基金成立于2008年1月，由国际传媒、教育、服务巨头贝塔斯曼集团全资控股，坚持走精品路线，依托贝塔斯曼集团在全球的资源网络，帮助创业者开拓布局，也用更为长期和战略的眼光陪伴企业成长。",
          aboutTItle2: "关于BAI梦想基金",
          aboutDetail2: "2014年10月，BAI正式成立了规模达数千万美元的专项天使基金，关注移动、社交、智能硬件、游戏、教育、企业服务和内容等优秀的早期公司。BetaFund将为天使阶段的创业者提供资金支持和各个运营阶段的专业服务，实现创业投资的闭环，并积极推动被投企业与贝塔斯曼业务单元的紧密合作，实现协同效应。目前，BetaFund中多数公司都实现了下一轮融资，并得到了BAI的持续支持。",
          aboutTItle3: "关于贝塔斯曼集团",
          aboutDetail3: "贝塔斯曼集团成立于1835年，是全球领先的传媒巨擘，业务遍及50多个国家。整个联营集团包括八大业务单元。2019 财年，贝塔斯曼集团营收达到 180亿欧元。贝塔斯曼是创造力与创业家精神的代名词，为全球客户带来顶尖的媒体服务与创新解决方案。"
        }
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.animateCtrl[0] = 1;
    document.body.scrollTop = 0;
    this.current = +this.$route.query.page || 0;
    this.animateCtrl[this.current - 1] = 1;
    this.turnTo(this.current);
    window.$http.get(window.hostName + "wp-json/wp/v2/about?per_page=100").then(function (res) {
      var aboutList = res.data.map(function (item) {
        return {
          title: item.title.rendered,
          content: item.content.rendered,
          main_title: item.main_title,
          award: item.award,
          institutions: item.institutions,
          categories: item.categories[0]
        };
      }).filter(function (item) {
        if (_this.lang === "zh") {
          return (/[\u4e00-\u9fa5]/.test(item.title) || /[\u4e00-\u9fa5]/.test(item.content)
          );
        } else {
          return !/[\u4e00-\u9fa5]/.test(item.title) && !/[\u4e00-\u9fa5]/.test(item.content);
        }
      }).slice(0, 6);
      _this.aboutList = aboutList.filter(function (item) {
        return item.categories !== 71;
      });
      _this.detail = aboutList.filter(function (item) {
        return item.categories === 71;
      })[0].content.split("\n").slice(0, -1);
    }).catch(function (err) {
      console.log("err:", err);
    });
  },

  components: {
    bFooter: __WEBPACK_IMPORTED_MODULE_1__footer___default.a,
    bHeader: __WEBPACK_IMPORTED_MODULE_0__header___default.a
  },
  computed: {
    lang: function lang() {
      return localStorage.lang;
    },
    isMobi: function isMobi() {
      return window.isMobi;
    },
    totalPage: function totalPage() {
      return 0;
    }
  },
  methods: {
    beforeEnter: function beforeEnter(el) {
      window.Velocity.hook(el, "translateY", "-20px");
      window.Velocity.hook(el, "opacity", 0);
    },
    turnToA: function turnToA(page) {
      this.animateCtrl[page] = page;
      if (this.isMobi && page) {
        this.turnTo(page + 1);
        this.$moveTo(page + 1);
      } else {
        this.turnTo(page);
        this.$moveTo(page);
      }
    },

    enter: function enter(el, done) {
      var delay = el.dataset.index * 50;
      window.Velocity(el, {
        opacity: 1,
        translateY: 0
      }, {
        duration: 500,
        delay: delay,
        complete: done
      });
    },
    beforeLeftEnter: function beforeLeftEnter(el) {
      window.Velocity.hook(el, "translateX", el.dataset.index % 2 ? "100px" : "-100px");
      window.Velocity.hook(el, "opacity", 0);
    },
    leftenter: function leftenter(el, done) {
      var delay = el.dataset.index * 50;
      window.Velocity(el, {
        opacity: 1,
        translateX: 0
      }, {
        duration: 500,
        delay: delay,
        complete: done
      });
    },
    mousewheel_about: function mousewheel_about(e) {
      var top = this.$refs.about.scrollTop;
      if (top <= 0 && e.deltaY < 0 || top >= this.$refs.about.scrollHeight - this.$refs.about.clientHeight && e.deltaY > 0) {
        this.mousewheel(e);
      }
    },
    linkto: function linkto(url) {
      window.location.href = url;
    }
  }
};
/* harmony default export */ __webpack_exports__["default"] = (About);

/***/ }),

/***/ 215:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js__);



var Banner = {
  props: ['imgs'],
  data: function data() {
    return {
      scale: 1,
      showPage: 0,
      animate: null
    };
  },
  mounted: function mounted() {
    this.turn();
  },

  components: {},
  computed: {},
  methods: {
    turn: function turn() {
      var _this2 = this;

      var _this = this;
      this.animate = new __WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js___default.a.Tween({
        scale: 1
      }).to({
        scale: 1.2
      }, 4000).onUpdate(function () {
        _this.scale = this.scale;
      }).onComplete(function () {
        _this.turn();
        _this2.showPage = ++_this2.showPage % _this2.imgs.length;
      }).start();
    },
    next: function next() {
      this.showPage = (++this.showPage + this.imgs.length) % this.imgs.length;
      this.animate.stop();
      this.turn();
    },
    prev: function prev() {
      this.showPage = (--this.showPage + this.imgs.length) % this.imgs.length;
      this.animate.stop();
      this.turn();
    }
  }
};
/* harmony default export */ __webpack_exports__["default"] = (Banner);

/***/ }),

/***/ 216:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__footer__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__header__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixin_fanpage_js__ = __webpack_require__(36);






var Belief = {
  props: [],
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixin_fanpage_js__["a" /* default */]],
  data: function data() {
    return {
      list: [],
      random: {},
      langs: {
        en: {
          belief: 'OUR BELIEF',
          detail1: 'We hope all the entrepreneurs backed by BAI ',
          detail2: 'grow to role models for youth in the future',
          auther: 'Annabelle Long'
        },
        zh: {
          belief: '我们的理念',
          detail1: '我们希望BAI支持的每一位创业者，',
          detail2: '都能成为未来青年的榜样',
          auther: '龙宇'
        }
      }
    };
  },

  filters: {},
  mounted: function mounted() {
    var _this = this;

    window.$http.get(window.hostName + 'wp-json/wp/v2/belief?per_page=100').then(function (res) {
      _this.list = res.data.map(function (item, index) {
        return {
          title: item.title.rendered,
          avatar: item.avatar.guid || 'http://via.placeholder.com/80x80',
          link: item.link,
          time: item.timeline.slice(-4),
          name: item.author_name,
          top: index
        };
      }).filter(function (item) {
        if (_this.lang === 'zh') {
          return (/[\u4e00-\u9fa5]/.test(item.title) || /[\u4e00-\u9fa5]/.test(item.content)
          );
        } else {
          return !/[\u4e00-\u9fa5]/.test(item.title) && !/[\u4e00-\u9fa5]/.test(item.content);
        }
      }).slice(0, 8);
      _this.list = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.sortBy(_this.list, function (n) {
        return n.time;
      });
      var start = 0;
      var newList = [];
      _this.list.forEach(function (item, index) {
        if (item.time > start) {
          newList.push({
            type: 'time',
            time: item.time
          });
          start = item.time;
        }
        newList.push(item);
      });
      _this.list = newList;
    });
  },

  components: {
    bFooter: __WEBPACK_IMPORTED_MODULE_1__footer___default.a,
    bHeader: __WEBPACK_IMPORTED_MODULE_2__header___default.a
  },
  computed: {
    lang: function lang() {
      return localStorage.lang;
    },
    isMobi: function isMobi() {
      return window.isMobi;
    }
  },
  methods: {
    beforeEnter: function beforeEnter(el) {
      window.Velocity.hook(el, 'translateY', '-20px');
      window.Velocity.hook(el, 'opacity', 0);
    },
    enter: function enter(el, done) {
      var delay = el.dataset.index * 50;
      window.Velocity(el, {
        opacity: 1,
        translateY: 0
      }, {
        duration: 500,
        delay: delay,
        complete: done
      });
    },
    openLink: function openLink(link) {
      window.open(link);
    }
  }
};
/* harmony default export */ __webpack_exports__["default"] = (Belief);

/***/ }),

/***/ 217:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__footer__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixin_fanpage_js__ = __webpack_require__(36);





var Contact = {
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixin_fanpage_js__["a" /* default */]],
  props: [],
  data: function data() {
    return {
      totalPage: 0,
      langs: {
        en: {
          contact: 'CONTACT US',
          weibo: 'WEIBO',
          wechat: 'WeChat Official Account',
          bp: 'BP',
          joinus: 'JOIN US',
          firstName: 'First name',
          secondName: 'Last name',
          email: 'E-mail Address',
          subscribeNews: 'Subscribe to get notifications about BAI events,news,and opportunities',
          subscribe: 'Subscribe',
          copyright: '©2019 Bertelsmann Asia Investments ALL RIGHTS RESERVED'
        },
        zh: {
          contact: '联系我们',
          weibo: '微博',
          wechat: '微信公众号',
          bp: '商业计划书',
          joinus: '加入我们',
          firstName: '名字',
          secondName: '姓氏',
          email: 'E-mail',
          subscribeNews: '订阅通知&新闻',
          subscribe: '订阅',
          copyright: '©2019 贝塔斯曼亚洲投资基金 ALL RIGHTS RESERVED'
        }
      }
    };
  },
  mounted: function mounted() {
    this.animateCtrl[0] = true;
  },

  components: {
    bHeader: __WEBPACK_IMPORTED_MODULE_0__header___default.a,
    bFooter: __WEBPACK_IMPORTED_MODULE_1__footer___default.a
  },
  computed: {
    lang: function lang() {
      return localStorage.lang;
    }
  },
  methods: {
    beforeEnter: function beforeEnter(el) {
      window.Velocity.hook(el, 'translateX', '0%');
      window.Velocity.hook(el, 'translateY', '50px');
      window.Velocity.hook(el, 'opacity', 0);
    },
    next: function next() {
      this.turnTo(++this.currentPage);
    },
    enter: function enter(el, done) {
      window.Velocity(el, {
        opacity: 1,
        translateY: 0
      }, {
        duration: 500,
        delay: 300,
        complete: done
      });
    }
  }
};
/* harmony default export */ __webpack_exports__["default"] = (Contact);

/***/ }),

/***/ 218:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var Footer = {
  props: [],
  data: function data() {
    return {
      langs: {
        zh: {
          baiChina: "贝塔斯曼中国总部",
          baiSE: "贝塔斯曼集团总部",
          contact: "地址",
          follow: "合作",
          more: "更多",
          addressBeijing: "北京市朝阳区新源南路8号启皓北京西塔16层1609室",
          postBeijing: "邮编100027",
          addressShanghai: "上海市徐汇区永嘉路750号4楼",
          postShanghai: "邮编200031",
          join: "加入我们",
          bp: "商业计划书"
        },
        en: {
          baiChina: "Bertelsmann China Corporate Center",
          baiSE: "Bertelsmann SE& Co.KGaA",
          contact: "Locations",
          follow: "Cooperation",
          more: "More",
          addressBeijing: "Unit 1609, 16F, West Tower, Genesis Beijing, 8 Xinyuan South Rd., Chaoyang District, Beijing。",
          postBeijing: "Beijing 100027, P.R.China",
          addressShanghai: "4F, 750 Yongjia Rd. Xuhui District, Shanghai",
          postShanghai: "Shanghai 200031, PR China",
          join: "join us",
          bp: "BP"
        }
      },
      mapBeijing: null,
      mapShanghai: null
    };
  },
  mounted: function mounted() {
    this.mapBeijing = new window.AMap.Map("map", {
      center: [116.4561, 39.9476],
      scrollWheel: false,
      zoom: 16
    });
    this.mapShanghai = new window.AMap.Map("map", {
      center: [121.446711, 31.204105],
      scrollWheel: false,
      zoom: 16
    });
    var markerBeijing = new window.AMap.Marker({
      position: [116.4561, 39.9476],
      offset: new window.AMap.Pixel(-12, -12),
      map: this.mapBeijing
    });
    var markerShanghai = new window.AMap.Marker({
      position: [121.446711, 31.204105],
      offset: new window.AMap.Pixel(-12, -12),
      map: this.mapShanghai
    });
    console.log("markerBeijing, markerShanghai:", markerBeijing, markerShanghai);
  },

  components: {},
  computed: {
    lang: function lang() {
      return localStorage.lang;
    }
  },
  methods: {}
};
/* harmony default export */ __webpack_exports__["default"] = (Footer);

/***/ }),

/***/ 219:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rightbar__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rightbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__rightbar__);



var Header = {
  props: [],
  data: function data() {
    return {
      showRight: false
    };
  },

  components: {
    rightbar: __WEBPACK_IMPORTED_MODULE_0__rightbar___default.a
  },
  computed: {},
  methods: {
    toIndex: function toIndex() {
      this.$router.push('/');
    },
    show: function show() {
      this.showRight = true;
    },
    close: function close() {
      this.showRight = false;
    }
  }
};
/* harmony default export */ __webpack_exports__["default"] = (Header);

/***/ }),

/***/ 220:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__timeline__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__timeline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__banner__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__banner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__banner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__slider__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__slider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__page__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixin_fanpage_js__ = __webpack_require__(36);








var Index = {
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixin_fanpage_js__["a" /* default */]],
  props: [],
  data: function data() {
    return {
      opts: {
        der: 0.2
      },
      langs: {
        en: {
          bannerTitle1: "Bertelsmann Asia Investments",
          bannerTitle2: "Empower Future Business Leaders",
          aboutTItle1: "About BAI",
          aboutDetail1: "Bertelsmann’s investment arm in idea of creating better history with first movers.",
          aboutTItle2: "About Betafund",
          aboutDetail2: "about Betafund: an angel fund supporting entrepreneurs who dream what they want to dream.",
          aboutTItle3: "About Bertelsmann",
          aboutDetail3: "about Bertelsmann: an international media, services and education company.",
          portfolio: "PORTFOLIO",
          list: "LIST",
          companyTitle1: ">3 Billion",
          companydetail1: "Asset Under Management",
          companyTitle2: ">160",
          companydetail2: "Invested startups",
          companyTitle3: "> 500 Million",
          companydetail3: "Combined DAU",
          companyTitle4: ">140 Billion",
          companydetail4: "Combined Market Cap",
          teamTitle: "OUR TEAM",
          teamDetail1: "INVESTMENT",
          teamDetail2: "AS A SERVICE",
          news: "NEWS",
          contact: "CONTACT US",
          service: "Services",
          more: "More Bertelsmann",
          network: "Bertelsmann Network",
          join: "Join Us",
          bp: "BP",
          index_1: "ABOUT BAI",
          index_2: "OUR BELIEF",
          index_3: "PORTFOLIO",
          index_4: "OUR TEAM",
          index_5: "NEWS",
          index_6: "CONTACT US",
          baiChina: "Bertelsmann China Corporate Center",
          baiSE: "Bertelsmann SE& Co.KGaA",
          addressBeijing: "Unit 1609, 16F, West Tower, Genesis Beijing, 8 Xinyuan South Rd., Chaoyang District",
          postBeijing: "Beijing 100027, P.R.China",
          addressShanghai: "4F, 750 Yongjia Rd.",
          postShanghai: "Shanghai 200031, PR China",
          beijing: "BEIJING",
          shanghai: "SHANGHAI"
        },
        zh: {
          bannerTitle1: "贝塔斯曼亚洲投资基金",
          bannerTitle2: "成就未来商业领袖",
          aboutTItle1: "关于 BAI",
          aboutDetail1: "与先行者推动更好的历史",
          aboutTItle2: "关于BAI梦想基金",
          aboutDetail2: "支持“敢想敢做”的创业者",
          aboutTItle3: "关于贝塔斯曼集团",
          aboutDetail3: "国际领先的传媒、教育、服务巨擘",
          portfolio: "被投企业",
          list: "列表",
          companyTitle1: ">30亿美金 ",
          companydetail1: "管理资金规模",
          companyTitle2: ">160",
          companydetail2: "投资公司数量",
          companyTitle3: ">5亿人次",
          companydetail3: "所提供的服务每月触及",
          companyTitle4: ">1400亿美金",
          companydetail4: "投资公司市值总和",
          teamTitle: "我们的团队",
          teamDetail1: "投资",
          teamDetail2: "即服务",
          news: "新闻",
          contact: "联系我们",
          service: "服务",
          more: "更多贝塔斯曼",
          network: "贝塔斯曼网络",
          join: "加入我们",
          bp: "商业计划书",
          index_1: "关于",
          index_2: "理念",
          index_3: "投资",
          index_4: "团队",
          index_5: "动态",
          index_6: "联系",
          baiChina: "贝塔斯曼中国总部",
          baiSE: "贝塔斯曼集团总部",
          addressBeijing: "北京市朝阳区新源南路8号启皓北京西塔16层1609室",
          postBeijing: "邮编100027",
          addressShanghai: "上海市徐汇区永嘉路750号4楼",
          postShanghai: "邮编200031",
          beijing: "北京",
          shanghai: "上海"
        }
      },
      showNews: 0,
      indexTime: 0,
      banner: [{
        img: __webpack_require__(481)
      }, {
        img: __webpack_require__(482)
      }, {
        img: __webpack_require__(483)
      }],
      showingCity: "",
      map: null,
      totalPage: 1,
      newsList: [],
      teamList: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    document.body.scrollTop = 0;

    this.map = new window.AMap.Map("map", {
      center: [116.4561, 36.9476],
      scrollWheel: false,
      zoom: 4
    });
    this.markers = [new window.AMap.Marker({
      position: [116.4561, 39.9476],
      offset: new window.AMap.Pixel(-12, -12),
      map: this.map
    }), new window.AMap.Marker({
      position: [121.446711, 31.204105],
      offset: new window.AMap.Pixel(-12, -12),
      map: this.map
    })];
    setTimeout(function () {
      _this.animateCtrl = [1];
      _this.map.addControl(new window.AMap.ToolBar());
    }, 10);
  },

  components: {
    bHeader: __WEBPACK_IMPORTED_MODULE_0__header___default.a,
    timeline: __WEBPACK_IMPORTED_MODULE_1__timeline___default.a,
    banner: __WEBPACK_IMPORTED_MODULE_2__banner___default.a,
    page: __WEBPACK_IMPORTED_MODULE_4__page___default.a,
    slider: __WEBPACK_IMPORTED_MODULE_3__slider___default.a
  },
  computed: {
    lang: function lang() {
      return localStorage.lang;
    },
    showFooter: function showFooter() {
      var docEl = document.documentElement;
      var clientWidth = docEl.clientWidth;
      if (!clientWidth) return "hidden";
      var remSize = 20 * (clientWidth / 320);
      return parseFloat(this.height) > remSize * 8.5;
    },
    isMobi: function isMobi() {
      return window.isMobi;
    }
  },
  methods: {
    getNews: function getNews() {
      var _this2 = this;

      var lang = "";
      if (this.lang === "zh") {
        lang = 54;
      } else {
        lang = 56;
      }
      window.$http.get(window.hostName + ("wp-json/wp/v2/news?page=1&per_page=3&tags=" + lang)).then(function (res) {
        _this2.newsList = res.data.map(function (item) {
          return {
            img: item.image.guid,
            title: item.title.rendered,
            content: item.content.rendered,
            link: item.link
          };
        });
      });
    },
    getTeam: function getTeam() {
      var _this3 = this;

      window.$http.get(window.hostName + "wp-json/wp/v2/index_team?page=1&per_page=3").then(function (res) {
        _this3.teamList = res.data.map(function (item) {
          return {
            title: item.title.rendered,
            content: item.content.rendered.match(/http(.*?)(jpg|png)/)[0]
          };
        });
      });
    },
    openLink: function openLink(link) {
      window.open(link);
    },
    switchCity: function switchCity(city) {
      this.showingCity = city;
      var options = {
        beijing: new window.AMap.LngLat(116.4561, 39.9476),
        shanghai: new window.AMap.LngLat(121.446711, 31.204105)
      };
      this.map.setCenter(options[this.showingCity]);
      this.map.setZoom(16);
      this.turnTo(1);
    },
    showRight: function showRight() {
      this.$refs.rightbar.show = true;
    },
    banner_resetTime: function banner_resetTime() {
      this.$refs.banner.next();
      this.$refs.banner_navigation.auto();
    },
    bannerPrev: function bannerPrev() {
      this.$refs.banner.prev();
      this.$refs.banner_timeline.reset();
    },
    bannerNext: function bannerNext() {
      this.$refs.banner.next();
      this.$refs.banner_timeline.reset();
    },
    news_resetTime: function news_resetTime() {
      this.nextNews();
    },
    newsPrev: function newsPrev() {
      if (this.showNews > 0) {
        this.showNews--;
      } else {
        this.showNews = this.newsList.length - 1;
      }
      this.$refs.news_timeline.reset();
    },
    newsNext: function newsNext() {
      this.nextNews();
    },
    nextNews: function nextNews() {
      if (this.showNews < this.newsList.length - 1) {
        this.showNews++;
      } else {
        this.showNews = 0;
      }
      this.$refs.news_timeline.reset();
    },
    turnTop: function turnTop() {
      this.turnTo(0);
    },
    turnNext: function turnNext() {
      this.turnTo(1);
    }
  }
};
/* harmony default export */ __webpack_exports__["default"] = (Index);

/***/ }),

/***/ 221:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__footer_vue__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__footer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_vue__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixin_fanpage_js__ = __webpack_require__(36);





var News = {
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixin_fanpage_js__["a" /* default */]],
  props: [],
  data: function data() {
    return {
      newsList: [],
      oldNewsList: [],
      langs: {
        en: {
          news: 'NEWS',
          more: 'LEARN MORE',
          moreNews: 'More News'
        },
        zh: {
          news: '新闻',
          more: '了解更多',
          moreNews: '更多新闻'
        }
      }
    };
  },

  filters: {
    time: function time(date) {
      return date.slice(0, 7);
    }
  },
  mounted: function mounted() {
    var _this = this;
    var lang = '';
    document.body.scrollTop = 0;
    if (_this.lang === 'zh') {
      lang = 54;
    } else {
      lang = 56;
    }
    window.$http.get(window.hostName + ('wp-json/wp/v2/news?page=1&per_page=30&tags=' + lang)).then(function (res) {
      var allnews = res.data.map(function (item) {
        return {
          img: item.image.guid,
          title: item.title.rendered,
          content: item.content.rendered,
          link: item.link,
          media_logo: item.media_logo.guid,
          media: item.media,
          date: item.date,
          tags: item.tags
        };
      });
      _this.newsList = allnews.slice(0, 6);
      _this.oldNewsList = allnews.slice(6, -1);
    });
  },

  components: {
    bFooter: __WEBPACK_IMPORTED_MODULE_0__footer_vue___default.a,
    bHeader: __WEBPACK_IMPORTED_MODULE_1__header_vue___default.a
  },
  computed: {
    lang: function lang() {
      return localStorage.lang;
    },
    mobi: function mobi() {
      return window.isMobi;
    },
    totalPage: function totalPage() {
      return this.mobi ? 0 : 1;
    }
  },
  methods: {
    openLink: function openLink(link) {
      window.open(link);
    },

    beforeEnter: function beforeEnter(el) {
      window.Velocity.hook(el, 'scale', 0);
      window.Velocity.hook(el, 'opacity', 0);
    },
    enter: function enter(el, done) {
      window.Velocity(el, {
        opacity: 1,
        scale: 1
      }, {
        duration: 1000,
        easing: 'easeOutBounce',
        complete: done
      });
    },
    morenews: function morenews(el) {
      this.turnTo(2);
    },
    moremousewheel: function moremousewheel(el) {
      var top = this.$refs.iteam.scrollTop;
      if (top <= 0 && el.deltaY < 0 || top >= this.$refs.iteam.scrollHeight - this.$refs.iteam.clientHeight && el.deltaY > 0) {
        this.mousewheel(el);
      }
      return el;
    }
  }
};
/* harmony default export */ __webpack_exports__["default"] = (News);

/***/ }),

/***/ 222:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var Page = {
  props: ['total'],
  data: function data() {
    return {
      current: 1
    };
  },
  mounted: function mounted() {},

  components: {},
  computed: {},
  methods: {
    prev: function prev() {
      this.current--;
      if (this.current === 0) this.current = this.total;
      this.$emit('prev');
    },
    next: function next() {
      if (this.current === this.total) {
        this.current = 1;
      } else {
        this.current++;
      }
      this.$emit('next');
    },
    auto: function auto() {
      if (this.current === this.total) {
        this.current = 1;
      } else {
        this.current++;
      }
    }
  }
};
/* harmony default export */ __webpack_exports__["default"] = (Page);

/***/ }),

/***/ 223:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__footer__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__header__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixin_fanpage_js__ = __webpack_require__(36);







var Portfolio = {
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixin_fanpage_js__["a" /* default */]],
  props: [],
  data: function data() {
    return {
      totalPage: 1,
      current: 0,
      currentCat: 0,
      opend: false,
      currentLogo: -1,
      moving: false,
      list: [],
      langs: {
        en: {
          portfolio: 'PORTFOLIO',
          all: 'ALL',
          Upgrade: 'Urbanization and Retail',
          Finance: 'Finance',
          Global: 'China Based Global Company',
          Social: 'Social, Media & Content',
          Tech: 'Tech & Infrastructure',
          bai: 'Bertelsmann’s investment arm in ideal of creating better history with first movers',
          FOF: 'Fund investments broadening BAI’s network and knowledge base',
          dream: 'An angel fund supporting entrepreneurs who dream what they want to dream'
        },
        zh: {
          portfolio: '被投企业',
          all: '全部',
          Upgrade: '城镇化与零售',
          Finance: '新金融',
          Global: '移动出海',
          Social: '社交/媒体/内容',
          Tech: '新科技/企业服务',
          bai: '由国际传媒、教育、服务巨头贝塔斯曼集团全资控股，旗下管理的资金规模超过30亿美元，坚持走精品路线，寻找早期到成长期的市场领先者，创新开创者和趋势引领者',
          FOF: '基金投资拓展BAI的投资领域和知识体系',
          dream: '数千万美金规模的天使基金，支持“敢想敢做”的创业者'
        }
      }
    };
  },
  beforeMount: function beforeMount() {
    this.animateCtrl = [];
    this.currentCat = +this.$route.query.cat || 0;
    this.current = +this.$route.query.id || 0;
    if (this.current) this.opend = true;
    this.currentPage = +this.$route.query.page || 0;
    this.getPortfolio({
      categories: this.currentCat
    });
  },
  mounted: function mounted() {
    this.turnTo(this.currentPage);
  },

  components: {
    bFooter: __WEBPACK_IMPORTED_MODULE_2__footer___default.a,
    bHeader: __WEBPACK_IMPORTED_MODULE_3__header___default.a
  },
  computed: {
    lang: function lang() {
      return localStorage.lang;
    },
    currentIndex: function currentIndex() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findIndex(this.list, { id: this.current });
    },
    currentCatList: function currentCatList() {
      var result = [];
      if (this.currentPage === 1) {
        if (this.currentCat === 0) {
          result = this.list;
        } else {
          result = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.list, { categories: this.currentCat });
        }
      } else if (this.currentPage === 2) {
        result = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.list, { categories: 42 });
      } else if (this.currentPage === 3) {
        result = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.list, { categories: 44 });
      }
      if (this.isMobi) {
        return result;
      } else {
        var len = (9 - result.length % 9) % 9;
        return result.concat(new Array(len).fill(''));
      }
    },
    isMobi: function isMobi() {
      return window.isMobi;
    }
  },
  methods: {
    turnToA: function turnToA(page) {
      this.turnTo(page);
      this.$moveTo(page);
    },
    touchend: function touchend(e) {
      var dom = this.$refs.protfolioList;
      if (dom.scrollTop === dom.scrollHeight - dom.clientHeight) {
        this.getPortfolio({
          categories: this.currentCat,
          page: Math.floor(dom.scrollTop / dom.clientHeight) + 1
        });
      }
    },
    getPortfolio: function getPortfolio(options) {
      var _this2 = this;

      var lang = '';
      var cate = '';
      if (this.lang === 'zh') {
        lang = 54;
      } else {
        lang = 56;
      }
      if (options.categories) {
        cate = '&categories=' + options.categories;
      }
      if (!options.page) {
        options.page = 1;
      }
      window.$http.get(window.hostName + ('wp-json/wp/v2/portfolio?per_page=18&page=' + options.page + '&tags=' + lang) + cate).then(function (res) {
        var list = _this2.list;
        list.push.apply(list, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(res.data.map(function (item) {
          return {
            id: item.id,
            link: item.link,
            logo: item.logo.guid,
            title: item.title.rendered,
            title_en: item.title_en || item.title.rendered,
            content: item.content.rendered,
            content_en: item.content_en || item.content.rendered,
            categories: item.categories[0]
          };
        })));
        _this2.list = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqBy(list, function (item) {
          return item.id;
        });

        _this2.$nextTick(function () {
          this.turnTo(this.currentPage);
        });
      });
    },
    openLink: function openLink(link) {
      window.open(link);
    },
    parent: function parent(e, query) {
      for (var i = e.target; i !== document.rootElement; i = i.parentNode) {
        if (i.className.indexOf(query) !== -1) return i;
      }
      return null;
    },
    close: function close() {
      this.opend = false;
    },
    open: function open() {
      this.opend = true;
    },
    mouseEnter: function mouseEnter(index) {
      if (this.currentCatList[index]) {
        this.currentLogo = index;
      }
    },
    mouseLeave: function mouseLeave() {
      this.currentLogo = -1;
    },
    setCurrent: function setCurrent(id) {
      if (this.currentCatList[id]) {
        this.current = this.currentCatList[id].id;
        this.opend = true;
      }
    },
    setCat: function setCat(id) {
      if (this.opend) return;
      this.currentCat = id;
      if (this.mobi) {
        this.currentPage = 1;
      } else {
        this.currentPage = +this.$route.query.page + 1 || 0;
      }
      this.getPortfolio({
        categories: this.currentCat
      });
    },

    beforeEnter: function beforeEnter(el) {
      window.Velocity.hook(el, 'translateX', '-200px');
      window.Velocity.hook(el, 'opacity', 0);
    },
    enter: function enter(el, done) {
      var delay = el.dataset.index * 50 * Math.random();
      window.Velocity(el, {
        opacity: 1,
        translateX: 0
      }, {
        duration: 1000,
        delay: delay,
        complete: done
      });
    },
    wheel: function wheel(e) {
      var _this3 = this;

      if (this.moving) return;
      var _this = this;
      this.moving = true;
      var dom = this.parent(e, 'table');
      var direction = e.deltaY > 0 ? 1 : -1;
      var height = dom.scrollTop;
      window.Velocity(dom, 'scroll', {
        offset: 20,
        mobileHA: false,
        progress: function progress(elements, complete, remaining, start, tweenValue) {
          dom.scrollTop = height + direction * dom.clientHeight * complete;
        },
        complete: function complete() {
          setTimeout(function () {
            _this.getPortfolio({
              categories: _this3.currentCat,
              page: Math.floor(dom.scrollTop / dom.clientHeight) + 1
            });
            _this3.moving = false;
          }, 400);
        }
      });
    }
  }
};
/* harmony default export */ __webpack_exports__["default"] = (Portfolio);

/***/ }),

/***/ 224:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


__webpack_require__(490);
__webpack_require__(491);

var Rightbar = {
  props: [],
  data: function data() {
    return {
      langs: {
        en: {
          menu: "MENU"
        },
        zh: {
          menu: "菜单"
        }
      },
      list: [{
        link: "/about",
        title: {
          en: "ABOUT BAI",
          zh: "关于"
        }
      }, {
        link: "/contact",
        title: {
          en: "CONTACT US",
          zh: "联系"
        }
      }]
    };
  },
  mounted: function mounted() {},

  components: {},
  computed: {
    lang: function lang() {
      return localStorage.lang;
    }
  },
  methods: {
    close: function close() {
      this.$emit("close");
    },

    beforeEnter: function beforeEnter(el) {
      window.Velocity.hook(el, "translateX", "-100px");
      window.Velocity.hook(el, "opacity", 0);
    },
    enter: function enter(el, done) {
      var delay = el.dataset.index * 100;
      window.Velocity(el, {
        opacity: 1,
        translateX: 0
      }, {
        duration: 200,
        complete: done,
        delay: delay
      });
    },
    toggleLang: function toggleLang(lang) {
      localStorage.lang = lang;
      location.reload();
    }
  }
};
/* harmony default export */ __webpack_exports__["default"] = (Rightbar);

/***/ }),

/***/ 225:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var Slider = {
  props: [],
  data: function data() {
    return {
      swiper: null,
      hoverd: 0,
      list: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    window.$http.get(window.hostName + 'wp-json/wp/v2/portfolio?tags=51').then(function (res) {
      _this.list = res.data.map(function (item) {
        return {
          id: item.id,
          logo: item.logo.guid,
          image: item.image.guid,
          title: item.title.rendered,
          title_en: item.title_en || item.title.rendered,
          slogan: item.slogan,
          slogan_en: item.slogan_en || item.slogan,
          categories: item.categories[0],
          tags: item.tags[0]
        };
      });
      _this.$nextTick(function () {
        if (document.body.clientWidth >= 720) {
          this.swiper = new window.Swiper('.swiper-container', {
            slidesPerView: 5,
            spaceBetween: 0,
            loop: true,
            autoplay: true,
            speed: 2000
          });
        } else {
          this.swiper = new window.Swiper('.swiper-container', {
            slidesPerView: 2,
            slidesPerColumn: 3,
            spaceBetween: 0,
            autoplay: true,
            speed: 5000
          });
        }
      });
    });
  },

  components: {},
  computed: {
    lang: function lang() {
      return localStorage.lang;
    }
  },
  methods: {
    pause: function pause() {
      this.swiper.stopAutoplay();
    },
    play: function play() {
      this.swiper.startAutoplay();
    }
  }
};
/* harmony default export */ __webpack_exports__["default"] = (Slider);

/***/ }),

/***/ 226:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixin_fanpage_js__ = __webpack_require__(36);






var Team = {
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixin_fanpage_js__["a" /* default */]],
  props: [],
  data: function data() {
    return {
      totalPage: 1,
      hoverIndex: -1,
      openIndexA: -1,
      openIndexB: -1,
      iteamList: [],
      piteamList: [],
      scrollTop: 0,
      langs: {
        en: {
          title: 'OUR TEAM',
          iteam: 'INVESTMENT TEAM',
          piteam: 'POST-INVESTMENT MANAGEMENT TEAM',
          introduction: 'INTRODUCTION'
        },
        zh: {
          title: '我们的团队',
          iteam: '投资团队',
          piteam: '投后管理团队',
          introduction: '简介'
        }
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    var list = [];
    this.totalPage = 1;
    this.animateCtrl[0] = 1;
    window.$http.get(window.hostName + 'wp-json/wp/v2/team?per_page=100').then(function (res) {
      list = res.data.map(function (item) {
        return {
          id: item.id,
          title: item.title.rendered,
          content: item.content.rendered,
          avatar: item.avatar.guid,
          link: item.link,
          email: item.email,
          categories: item.categories[0],
          jobTitle: item['job-title'],
          wechat: item.wechat
        };
      }).filter(function (item) {
        if (_this.lang === 'zh') {
          return (/[\u4e00-\u9fa5]/.test(item.title) || /[\u4e00-\u9fa5]/.test(item.content)
          );
        } else {
          return !/[\u4e00-\u9fa5]/.test(item.title) && !/[\u4e00-\u9fa5]/.test(item.content);
        }
      });
      _this.iteamList = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(list, { categories: 12 });
      _this.piteamList = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(list, { categories: 14 });
      _this.$nextTick(function () {
        window.addEventListener('scroll', this.onScroll, true);
      });
    });
  },

  components: {
    bHeader: __WEBPACK_IMPORTED_MODULE_1__header___default.a
  },
  computed: {
    isMobi: function isMobi() {
      return window.isMobi;
    },
    lang: function lang() {
      return localStorage.lang;
    }
  },
  methods: {
    slideDownA: function slideDownA(index) {
      if (this.openIndexA === index) {
        this.openIndexA = -1;
      } else {
        this.openIndexA = index;
      }
    },
    slideDownB: function slideDownB(index) {
      if (this.openIndexB === index) {
        this.openIndexB = -1;
      } else {
        this.openIndexB = index;
      }
    },
    close: function close() {
      this.openIndexA = -1;
      this.openIndexB = -1;
    },
    hover: function hover(index) {
      this.hoverIndex = index;
    },
    leave: function leave() {
      this.hoverIndex = -1;
    },
    sub_mousewheel_iteam: function sub_mousewheel_iteam(e) {
      var top = this.$refs.iteam.scrollTop;
      if (top <= 0 && e.deltaY < 0 || top >= this.$refs.iteam.scrollHeight - this.$refs.iteam.clientHeight && e.deltaY > 0) {
        this.mousewheel(e);
      }
    },
    onScroll: function onScroll() {
      if (this.currentPage === 1) {
        this.scrollTop = this.$refs.iteam.scrollTop;
      } else if (this.currentPage === 2) {
        this.scrollTop = this.$refs.ipteam.scrollTop;
      }
    },

    beforeEnter: function beforeEnter(el) {
      el.style.display = 'block';
    },
    enter: function enter(el, done) {
      var _this2 = this;

      var clone = el.cloneNode(true);
      el.appendChild(clone);
      var h = clone.clientHeight;
      clone.remove();
      var iteamHeight = this.$refs['iteam'].scrollTop;
      var ipteamHeight = this.$refs['ipteam'].scrollTop;
      window.Velocity.hook(el, 'height', 0);
      window.Velocity(el, {
        height: h
      }, {
        duration: 500,
        progress: function progress(_progress) {
          _this2.$refs['iteam'].scrollTop = iteamHeight + _progress[0].clientHeight + 50;
          _this2.$refs['ipteam'].scrollTop = ipteamHeight + _progress[0].clientHeight + 50;
        },
        complete: function complete() {
          done();
        }
      });
    },
    leaves: function leaves(el, done) {
      window.Velocity(el, {
        height: 0
      }, {
        duration: 500,
        complete: function complete() {
          el.style.removeProperty('height');
          done();
        }
      });
    },
    movieEnter: function movieEnter(e) {
      e.target.play();
    },
    movieLeave: function movieLeave(e) {
      e.target.pause();
    }
  }
};
/* harmony default export */ __webpack_exports__["default"] = (Team);

/***/ }),

/***/ 227:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js__);



var Timeline = {
  props: ['percent'],
  data: function data() {
    return {
      indexTime: 0
    };
  },
  mounted: function mounted() {
    this.indexTime = this.percent;
    this.timerIndex();
  },

  components: {},
  computed: {
    barStyle: function barStyle() {
      return {
        width: this.indexTime + '%'
      };
    }
  },
  methods: {
    animate: function animate(time) {
      requestAnimationFrame(this.animate);
      __WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js___default.a.update(time);
    },
    timerIndex: function timerIndex() {
      var _this = this;
      this.animate = new __WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js___default.a.Tween({
        indexTime: 0
      }).easing(__WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js___default.a.Easing.Quadratic.Out).to({
        indexTime: 100
      }, 4000).onUpdate(function () {
        _this.indexTime = this.indexTime;
      }).onComplete(function () {
        _this.indexTime = 0;
        _this.timerIndex();
        _this.$emit('reset');
      }).start();
    },
    reset: function reset() {
      this.animate.stop();
      this.indexTime = 0;
      this.timerIndex();
    }
  }
};
/* harmony default export */ __webpack_exports__["default"] = (Timeline);

/***/ }),

/***/ 228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_fullpage_vue_fullpage_css__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_fullpage_vue_fullpage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_fullpage_vue_fullpage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_fullpage__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_fullpage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_fullpage__);







__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;
window.$http = __WEBPACK_IMPORTED_MODULE_4_axios__["a" /* default */];
window.hostName =  true ? '' : 'http://baifund.com/';

if (!localStorage.lang) {
  localStorage.lang = /zh/.test(navigator.language) ? 'zh' : 'en';
}
(function (doc, win) {
  var docEl = doc.documentElement;
  var resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
  var recalc = function recalc() {
    var clientWidth = docEl.clientWidth;
    if (!clientWidth) return;
    docEl.style.fontSize = 20 * (clientWidth / 320) + 'px';
  };

  if (!doc.addEventListener) return;
  win.addEventListener(resizeEvt, recalc, false);
  recalc();

  doc.addEventListener('DOMContentLoaded', recalc, false);
  var u = navigator.userAgent;
  window.isMobi = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 || !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
})(document, window);



__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_fullpage___default.a);

window.bus = new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]();

new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),

/***/ 36:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js__);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      currentPage: 0,
      moving: false,
      opts: {},
      width: document.body.clientWidth,
      animateCtrl: [],
      init: false
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    window.onresize = function () {
      _this2.width = document.body.clientWidth;
    };
    this.$on("increment", function (e) {
      this.currentPage = e;
      this.animateCtrl.splice(e, 1, true);
    });
    this.$on("resize", function (e) {
      this.width = document.body.clientWidth;
    });
    this.animate();
    this.init = true;
  },

  computed: {
    height: function height() {
      if (this.width >= 720 && window.innerHeight > this.width / 16 * 9) {
        return this.width / 16 * 9 + "px";
      } else {
        return window.innerHeight + "px";
      }
    }
  },
  methods: {
    animate: function animate(time) {
      requestAnimationFrame(this.animate);
      try {
        __WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js___default.a.update(time);
      } catch (error) {}
    },
    turnTo: function turnTo(pageNum, height) {
      var _this3 = this;

      var _this = this;
      if (!this.$refs.fullpage) return;
      if (height) {
        this.$refs.iteam.scrollTo(this.$refs.iteam.scrollLeft, 47.194 * parseFloat(window.document.documentElement.style.fontSize));
      }
      this.animateCtrl.splice(pageNum, 1, true);

      new __WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js___default.a.Tween({
        height: this.$refs.fullpage.style.transform ? +this.$refs.fullpage.style.transform.match(/translate3d\(0px, (.*)px, 0px\)/)[1] : 0
      }).easing(__WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js___default.a.Easing.Quadratic.Out).to({
        height: -this.currentPage * parseFloat(this.height)
      }, 500).onUpdate(function () {
        _this.$refs.fullpage.style.transform = "translate3d(0px, " + this.height + "px, 0px)";
      }).onComplete(function () {
        _this3.currentPage = pageNum;
        window.setTimeout(function () {
          _this3.moving = false;
        }, 700);
      }).start();
    },
    mousewheel: function mousewheel(e) {
      if (this.moving) {
        return;
      }
      if (e.deltaY > 0 && this.currentPage < this.totalPage) {
        this.currentPage++;
        this.moving = true;
      } else if (e.deltaY < 0 && this.currentPage > 0) {
        this.currentPage--;
        this.moving = true;
      }
      this.turnTo(this.currentPage);
    }
  }
});

/***/ }),

/***/ 458:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 459:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 460:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 461:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 462:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 463:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 464:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 465:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 466:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 467:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 468:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 469:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 470:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 471:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 472:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 473:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "072873a115f1f6e1120b863cbf2ac6bd.mp4";

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "503df50b027515c4fe264bdc2aaef6eb.mp4";

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner_1.8d9b6ad.jpg";

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner_2.a00aa54.jpg";

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner_3.6782b88.jpg";

/***/ }),

/***/ 484:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF0AAAAyCAYAAAA+09dMAAAABGdBTUEAALGPC/xhBQAACbhJREFUeAHFXF1sHUcV/vZex3actGka7MQ3QJukqpPYTlpcmoYqpEmbVoEHKBB44JEK8YBUEAikIqEC4ueNB6hAlMIzDTxU/JS/SG4UnKZRaf5cx0BKVIivHSclza9zfe8dvvHe9d27d3fm7N7dm7GsnTnnzJkz3545MzsztqMwsqSIa39Bi0kB81RxXf86cGYc4B85/lbQM1bA65qeWTqHgefY5mDcBvLAM6txeixuvaD8FDY9Caing/Swcj8mdnUAc46C2hkmkJRGffwBqgsKrs5NYeMBZn9ZwOnfJNUZVW8KIz0KVz/HFruiZKLoZTgECy2DTgcrVGNgSGfMPHUTkI/y99cE/9Xz2Hx/mi06uKEdJjbgrg3q8TRtkepqB+iLthD4bWVUDxYxsGuR2GJGoZIYOHro8AyGVrdoQuzqbQVdW0fglzPs/GEaG4djWxtawUkMOkOgU2nhpYWaIyC2HfSaTd2Mgc8J7DOKXMDWtXyJm41CVmY18Uuzqo4QuFWg64l2xzls/liEXSJyGXNPiASNQs4evjhGmvYlrl7kicuy79G6d3w1GCpUH+l9DBwjBHKdj2fNOqh+gkIvWQUjBCpAy15KwFfPYmgrmzgW0Uzq5Jig4/l+nD4bZQXXqx8m+D9mR4TxWu1VeDbn4Fl3dRmlOISuvZPtPaZniahEBzlD7lryu6NkNH0eCyGmbaCnGl4KmDjYjWU76Pnjpk56PALSO4v9671ynGcRG0cI+CpTHYXcK7TlNZOMy2tvXE8VdN2BO/H6uwrOl+0ddSW45GNoSpJEq5Yxav6bQPvDCtuXCuRSEUkddG1VAZ85wKF9QWJhGbleiVyIjDWe55A7TE8/FFI3SOou4vLOIDGrciag6xhNbxfFyByqK+N27jwGlzM0bbfUu7QGpya60TVGB6C4LSX/yLJpDvIzAb3WiMjT6Yk3gkbZylVUHiGOnSY5Av0qdauVOHaJ30CSOcY6ckztxeFlCLoS6a4i924cg7Us3dYKkIPcWF2vPcRwNTQ4i4FCvU52OREwCZs3riw8nVyz/svLS59cX1pBZ8cO1/VVJXEd3HW06q3rTJ7LBHS9huaQvs9mFof/lV6cOmOT8/OnMPh++vqAnxbMs/Eq54ojHp3tSFYwohHk6WzlmQno0+5HktXTGSZ+r+NuvA7Y19RUeKoXk1c8vbUPunNeOfqpHnMdJloiDU7qoCsMdnL4/0BmnPMLmZxfyg46X6QvtCzWtYYYvqzeYsr7/Yut+zKpgq4noiLK3EtRD/naCM0yBPxxLSZiHRPqLQMuRR8NVegjEnTfJOoxZCGGtmce1zmPyVOVHWZMPZeDmleolh2oFVx98IuyyoMA5wMlqI9Qm3GfQ7dGUM52ouspecuu5Axe/CBBudNWj2efTZ6+BLlD8+AWmT1p0IUj1VXGTT/6kDzFAp3g/pxgB0xnMFlI4tB8PI+OT74HxwUxtrEjjLdWL2TvL/Rh4p+NNRk3MHiiiJNXqOO2IM9fZi8ensaWZWtw4pqfbsrnOC8ReJNIAy/V8NKgOVCgd/OGgPONAjoeXB1zxeKp4gu3gs7w0+Tlur6D/drNQ3mefvepOhXmdzbS0i1lCrpeutHcX/FD5cl+rLuLtwG4Hz9eStIFzhf0UEcyV4xF6ac9wqWjeiJKRxr0TEHngONeOT5ND/1WEf/+prvGTmZ2CfndDA3WcMj2Ir3ZQf6QrHV7GJPpCZfKFHTdJIEnDthCwJ4Bym/x4OEnOmaGm2Oi2jekGL7KCsuORmvJH9Ey0XyXQ5s3XsTQ+2xySfmZg+43jJ3J0+u/UEHp77PY1O/n2fOiT/TjpttktclRtPs5l+EtAetw9YNBL+G6WvmuyDlLCeRtXDpu4DPGYYS6l8vLl3k760MmkLy2OTLWVXDzHq8c9TSFlnodpUPMA/VyVG5h0n4hitsKPSbo+Hw/Js+GNejG68pn+VK+zhewIkwmQNvq4PpXSPtOgN5UrKJkXbXoSpy1IyfRulK946i+VC9H5ZxHk57fRmn06KmFlwLG3+bq5Ptd6Bqix73lNWB6Ms5/TR9ImGRqPBHo7EzkJOq10YG8aAXDF7NqGvtHvHppPlMD3TNqFU78lx37FIGnw5sTQV9eQXmvSUphH+cBtdsko3kMfUXTTQWvfh/Gp2nbGa9seiqURS/bpCOMFyu8hCkIo/XhzTd4WfSvxH1PGN9P49aCBn2/n+bPn8fJB1m+w08Ly/PFzPCO5L4wXpDGNmdp24Ygvbm8MHl/t5neGiUT0LVJ/DI8IAGdk/CgqQuM01Jvu4+yL5p01XnWQeiJbtfhj6PjqkdI45l6ePGMykO96eUtzwETPwboJjWJeBw9S7jTtCtRZUOlzEDnEBadfeqVDjvHMNuc3sHICo6Ebc2c9lFon3SkiY3KDHSxBRTkXcJlYfJzuM5Pf3Cn9talLEZalqBbj+s8KB1waz48pe5l4c2YqOpebl3cZZKIy8sS9LuFxtz0n2c21rFv5TbKZ1VKdwMsw9WLkk5AXL41J64a7plHeX0zp5HCIVIh5e1GqqzE0LWGkpI7jHrEPS/TapfKBHR3r6Qk3JPWa+bmVBEcWNRqHS5gckezBjuFN39/xBOfL9ok+XK4JbAvXzsIsYlb+amHF/c2QOmnXKN3WlunAD31dJic5JTIrZcbDasvoRFMYV21cganeD6bTkoV9CkMbSqi8icuAeNMgL8LdkXhET0CReGJ55OjwfrSsoOlB/nSib09xeyTUWGs8MKvzI9PYaAWDvKOextA9fKpt3W5XTr/AHvAfsiSPlDowZKXg9JFzD5EPbcH6c1lp1TFUusmV3M9l9KPN2a5XTFO3IeiZDx6DfRve+VWnjFBr/6w3lhl0UVErlKv6M+9dAdO/s9PcPOyjSa+7KOS/fhm/XUKPWSU9ltBpy9tu4htt6/Ckcv12slyqYaXOCbQy6/w7svT4XVEp0Ssmjye19tVr9Tz0Tl6esdNXN4dLSHn3DLQaeJXw+6+XMIw/0hACU52Fj5VR+VdjZLs4d8lLQ7aKKEaPZ3vhraDTg+fp4c+xQOPn4X18AZKXJ7ZP/21Hv0fNsJ0xKHpuM7QId2ci7NAiDSj3aAfo1ft4R3GF6Is4mQt7Jh6rdV47tnAlzzq5U1Pym2YwfB6k4yElznoBJkTj/NbBx1712Lyfp7u2GKoEPQ04rkLEe9mjkrA0jK8ySC0L1ojVy/8zyC4NhktYuYQVH2PZI5KbvLJf7CjigT5PwyT/HWO9mOY3r1wpc2siNyL2PLeOZTmWE9iz5+tCsUCPXSEG5I2qbH5DxL4IXdJaPOCRf8HC1yaJmP4OTYAAAAASUVORK5CYII="

/***/ }),

/***/ 485:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 486:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAAzCAYAAADYfStTAAAABGdBTUEAALGPC/xhBQAAAP5JREFUaAXt2qEOwjAQBuD/Rg1zCLAIFCM8AAmOR+ENsDwLT4Aj4TVIUHNYEIgZEsjSHpPVTdZ0zT/VLLne3XeqTeWFaufgTsjgU+jVAK7sFvMM+oEA0yKHRvwe2JCvkeKaE0pxKn5NpsCodrBH/+dw11IPt3ZWTgEKUIACFKAABSiQnYA8saoUdp9DZwK5G4FdOOghh4YAPfPEmvokOSFOKLKAcSgagbtFzttLOoE+etmYm1KAAhSgAAUoQAEKUCBEQBqsJz+0y5Dg1GK60+rbfNFuLfSSWnEh9XQvSXhJEgIXNYaXJFG5A5JxQgFoUUNEsRk/0cyiZu0tWfn5A3m6K3Hm+h16AAAAAElFTkSuQmCC"

/***/ }),

/***/ 487:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAABmCAYAAABSm2hyAAAABGdBTUEAALGPC/xhBQAABUVJREFUeAHtmluIVlUUx/3UsbykhJpkeIFSE5N6yaIeoguFTVBRGF2oSN8spYfwQYSeeoluREYS9SpROAqBPSbVwxhaWWg3ukCjpoQ64iW16bdmvuX8z5lzznfmO/v75hP2gj977bXX+u816+zvnDNn79q4ADIwMLAEmvlgbh1zaI+DPsG+Wq32L/32CslNBHeBt8AfoIycwGkreBzMaHnGTNIF1oJDoIqcJfhtMHs0SdfKOkP8KL6vgEUZMUex7QV+2Q+jW/V8WVyPnhXXj/1V8BpL5BRtNSHJaWAbSMufGF4Hd4AJjWbBZwnYAHpBWn7BsLQRR+E4BAvAt0DlKJ31YFJhcMEgsfeBb4DKcTr3F4TlDxG4AvytbOhvgCA/DnjGg2eA/fBcLqC8kJ9VxggB88FhZ6A9DZ7McK1sgncZ+BW4/IfySCliHKeCvR5Ja0mvKBXcpBP8M8Eu4HIS5aaGdDh97BG0Z8CtDYMCODDPDLAfuNj9e1YuNYMPuGe9fTrXuQUDzLkI/CM5bM6cBocJ4HtxfCfTscVG5u+WHM6hLx4xJcbV4nQMfeYIpzYZmPszyeWTxLQM1IA+4zckHNrcIZcbgd3GXJZfTAHLzW6ltXvr5IuDTSjEl36M59HDYS89Li+b3/i680P11prtPKdPS7+0CvMq8AMB9qLyHVDe0jx1x60SMMxjEwCXbnEqrRL8sBOk2pWlScQRjinglHAtHEfnajH0o18mMaVV4nYLj6q7SpOkHCHZLkSrbRnME5/9LIGz0h+Neq04rxFd7WIupe4Rr3mWrL1zutj7aLOyTwLfF13tYi6laj5zQya7kekvpFI4R39Tyjaa7ohk7Z87l0OujLZl+XxBzG1gB/gR9IBbsO+mbVbsPw6XORPRDC7nXWmmJbFe4h5sJjYnxq6MS5ctg0tGYrKtulSxsrGyVCAug7gM4jJo1RqIlY2VHapAvM+2aiXEysbKUoG4DOIyqC+DfqnEFaJ3gjpdkjhhazbx1UMGO0FNfNq6pJO1MwOdJJpPn32fnQxsB9FlQadkS0K6ezS0r4txh2dKu64TkiWP6yQn23G83B8K9sXPZfj7vVvGptU8dvLR78xgGmQ9G/hWjrU3jE1+Q7Myv50Y+Qm4PJXIB+s2H6H9NDHY5g7zr5VcjqAn7/8YloLz4nRnm3McnM4SA3p8YH1mHjhtkWQPoAc5CJE5WY6ROT+QHOwcwqRMVwZsm8m2l1x2ojQ8/5JJ1oSRuV70ievtY4U0ONnmm52mcHmzMCDQIJOtBLoMt5SiJmiTZ1pvP6TNvhylGIud4H4O2Baqy+coXcVRMoqzbvQayZfgKnGprMJnZxzsuJXKb3TyT3BkzUqA3eveAyq2Y/48KP9XZ5Fjg+MesAeofE3nmpyQxmaCLTk7UaHyM50nwJTGDMMe+Nu5htuB/XDTYley0tGBwZkguRvYbSQttmvdA54Fy8CVw6kNVs92tu0Z3w3sKh0EabG7z0saV1mH0JbFOmBPlCKxN7jfgR1dKRK7WpuB7nBWzjNBAPl0sBGkj+dhKiV9eL0LFieIS3QqHQ9hwoXMYW9H9wJ7UbZ34WnAxU5uHgR/ga9AD+jlDWqAdmyF5O1H5/JR6Gz8fTY0r/HpJnEQ/lYmGyRBJYnJajVC6rGyIaupXLGyWo2QeqxsyGoqV6ysViOkHisbsprKFSur1Qipx8qGrKZyxcpqNULqsbIhq6lcsbJajZB6rGzIaipXrKxWI6QeKxuymsoVK6vVCKnHyoaspnJV2lNQItP5Pj+VxnchT7J3cCTtU6X/P97hOCwrNmOEAAAAAElFTkSuQmCC"

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/total.f4b8a94.jpg";

/***/ }),

/***/ 489:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(467)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(219),
  /* template */
  __webpack_require__(512),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-571f8f58",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(471)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(214),
  /* template */
  __webpack_require__(516),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b25446dc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(472)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(517),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b87a7712",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(460)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(216),
  /* template */
  __webpack_require__(505),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1be9e46c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(465)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(217),
  /* template */
  __webpack_require__(510),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4b4dd465",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(469)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(220),
  /* template */
  __webpack_require__(514),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-72e49152",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(468)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(221),
  /* template */
  __webpack_require__(513),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-62b59544",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(470)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(515),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a28861cc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(473)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(223),
  /* template */
  __webpack_require__(518),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bf7bab66",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(466)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(511),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-517908fc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(461)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(225),
  /* template */
  __webpack_require__(506),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-232fdbac",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(458)
  __webpack_require__(459)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(226),
  /* template */
  __webpack_require__(504),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-180d17e8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(462)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(507),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2c4c264c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 504:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "team",
    style: ({
      height: _vm.height
    })
  }, [_c('b-header', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentPage !== 0 && Math.abs(_vm.scrollTop) < 100),
      expression: "currentPage !== 0 && Math.abs(scrollTop) < 100"
    }],
    staticClass: "sub_nav"
  })]), _c('div', {
    directives: [{
      name: "fullpage",
      rawName: "v-fullpage",
      value: (_vm.opts),
      expression: "opts"
    }],
    ref: "fullpage",
    staticClass: "container",
    on: {
      "mousewheel": _vm.mousewheel,
      "wheel": _vm.mousewheel
    }
  }, [(!_vm.isMobi) ? _c('div', {
    staticClass: "page pc",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticClass: "nav"
  }, [_c('transition', {
    attrs: {
      "name": "left-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.init),
      expression: "init"
    }],
    staticClass: "line"
  })]), _c('transition', {
    attrs: {
      "name": "right-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.init),
      expression: "init"
    }],
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].title))])]), _c('transition', {
    attrs: {
      "name": "bottom-in-delay"
    }
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.init),
      expression: "init"
    }]
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.turnTo(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].iteam))]), _c('li', {
    on: {
      "click": function($event) {
        return _vm.turnTo(1, 2)
      }
    }
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].piteam))])])])], 1), _c('div', {
    staticClass: "movie"
  }, [_c('video', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.isMobi ? __webpack_require__(475) : __webpack_require__(474),
      "autoplay": "autoplay",
      "loop": "loop"
    },
    on: {
      "mouseenter": _vm.movieEnter,
      "mouseleave": _vm.movieLeave
    }
  })])]) : _vm._e(), _c('div', {
    ref: "iteam",
    staticClass: "page",
    style: ({
      overflowY: 'scroll'
    }),
    on: {
      "mousewheel": function($event) {
        $event.stopPropagation();
        return _vm.sub_mousewheel_iteam.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "nav mobi"
  }, [_c('transition', {
    attrs: {
      "name": "left-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.init),
      expression: "init"
    }],
    staticClass: "line"
  })]), _c('transition', {
    attrs: {
      "name": "right-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.init),
      expression: "init"
    }],
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].title))])]), _c('transition', {
    attrs: {
      "name": "bottom-in-delay"
    }
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.init),
      expression: "init"
    }]
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.turnTo(0)
      }
    }
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].iteam))]), _c('li', {
    on: {
      "click": function($event) {
        return _vm.turnTo(1, 2)
      }
    }
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].piteam))])])])], 1), _vm._m(0), _c('div', {
    staticClass: "sub_title"
  }, [_c('transition', {
    attrs: {
      "name": "left-in"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.animateCtrl[1 - !!_vm.isMobi]),
      expression: "animateCtrl[1 - !!isMobi]"
    }]
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].iteam))])])], 1), _c('div', {
    staticClass: "peoples"
  }, _vm._l((_vm.iteamList), function(item, index) {
    return _c('div', {
      staticClass: "people",
      on: {
        "mouseenter": function($event) {
          return _vm.hover(index)
        },
        "mouseleave": _vm.leave,
        "click": function($event) {
          $event.stopPropagation();
          return _vm.slideDownA(index)
        }
      }
    }, [_c('img', {
      staticClass: "avatar",
      attrs: {
        "src": item.avatar
      }
    }), _c('transition', {
      attrs: {
        "name": "bottom-in"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.animateCtrl[1 - !!_vm.isMobi]),
        expression: "animateCtrl[1 - !!isMobi]"
      }],
      staticClass: "text",
      on: {
        "mousemove": function($event) {
          return _vm.hover(index)
        },
        "mouseleave": _vm.leave
      }
    }, [_c('div', {
      staticClass: "job-title"
    }, [_vm._v(_vm._s(item.jobTitle))]), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.title))])])]), _c('transition', {
      attrs: {
        "appear": "appear"
      },
      on: {
        "before-enter": _vm.beforeEnter,
        "enter": _vm.enter,
        "leave": _vm.leaves
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.openIndexA == index),
        expression: "openIndexA == index"
      }],
      staticClass: "descs"
    }, [_c('div', {
      staticClass: "desc"
    }, [_c('div', {
      staticClass: "introduction"
    }, [_vm._v(_vm._s(_vm.langs[_vm.lang].introduction) + ":")]), _c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    }), _c('div', {
      staticClass: "contact"
    }, [_c('div', {
      staticClass: "email"
    }, [_vm._v(_vm._s(item.email))]), _c('div', {
      staticClass: "wechat"
    }, [_vm._v(_vm._s(item.wechat))])])]), _c('div', {
      staticClass: "close",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.close.apply(null, arguments)
        }
      }
    }, [_c('span', {
      staticClass: "iconfont"
    }, [_vm._v("")]), _vm._v("close")])])])], 1)
  }), 0), _c('div', {
    staticClass: "sub_title"
  }, [_c('transition', {
    attrs: {
      "name": "left-in"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.animateCtrl[1 - !!_vm.isMobi]),
      expression: "animateCtrl[1 - !!isMobi]"
    }]
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].piteam))])])], 1), _c('div', {
    staticClass: "peoples"
  }, _vm._l((_vm.piteamList), function(item, index) {
    return _c('div', {
      staticClass: "people",
      on: {
        "mousemove": function($event) {
          return _vm.hover(index)
        },
        "click": function($event) {
          $event.stopPropagation();
          return _vm.slideDownB(index)
        },
        "mouseleave": _vm.leave
      }
    }, [_c('img', {
      staticClass: "avatar",
      attrs: {
        "src": item.avatar
      }
    }), _c('transition', {
      attrs: {
        "name": "bottom-in"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.animateCtrl[1 - !!_vm.isMobi]),
        expression: "animateCtrl[1 - !!isMobi]"
      }],
      staticClass: "text",
      on: {
        "mousemove": function($event) {
          return _vm.hover(index)
        },
        "mouseleave": _vm.leave
      }
    }, [_c('div', {
      staticClass: "job-title"
    }, [_vm._v(_vm._s(item.jobTitle))]), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.title))])])]), _c('transition', {
      attrs: {
        "appear": "appear"
      },
      on: {
        "before-enter": _vm.beforeEnter,
        "enter": _vm.enter,
        "leave": _vm.leaves
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.openIndexB == index),
        expression: "openIndexB == index"
      }],
      staticClass: "descs"
    }, [_c('div', {
      staticClass: "desc"
    }, [_c('div', {
      staticClass: "introduction"
    }, [_vm._v(_vm._s(_vm.langs[_vm.lang].introduction) + ":")]), _c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    }), _c('div', {
      staticClass: "contact"
    }, [_c('div', {
      staticClass: "email"
    }, [_vm._v(_vm._s(item.email))]), _c('div', {
      staticClass: "wechat"
    }, [_vm._v(_vm._s(item.wechat))])])]), _c('div', {
      staticClass: "close",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.close.apply(null, arguments)
        }
      }
    }, [_c('span', {
      staticClass: "iconfont"
    }, [_vm._v("")]), _vm._v("close")])])])], 1)
  }), 0)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "photo mobi"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(488)
    }
  })])
}]}

/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "belief",
    style: ({
      height: _vm.height
    })
  }, [_c('b-header'), _c('div', {
    directives: [{
      name: "fullpage",
      rawName: "v-fullpage",
      value: (_vm.opts),
      expression: "opts"
    }],
    ref: "fullpage",
    staticClass: "container"
  }, [_c('div', {
    staticClass: "page",
    style: ({
      height: _vm.height,
      overflowY: 'scroll',
      paddingBottom: '20px'
    })
  }, [_c('div', {
    staticClass: "nav"
  }, [_c('transition', {
    attrs: {
      "name": "left-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.init),
      expression: "init"
    }],
    staticClass: "line"
  })]), _c('transition', {
    attrs: {
      "name": "right-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.init),
      expression: "init"
    }],
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].belief))])])], 1), _c('div', {
    staticClass: "talk"
  }, [_c('p', [_vm._v(_vm._s(_vm.langs[_vm.lang].detail1)), _c('br'), _vm._v(_vm._s(_vm.langs[_vm.lang].detail2))])]), _c('div', {
    staticClass: "timeline"
  }, [_c('transition', {
    attrs: {
      "appear": "appear",
      "name": "left-in"
    }
  }, [_c('img', {
    staticClass: "line pc",
    attrs: {
      "src": __webpack_require__(489)
    }
  })]), _c('transition', {
    attrs: {
      "appear": "appear",
      "name": "top-in"
    }
  }, [_c('div', {
    staticClass: "line mobi"
  })]), _c('transition-group', {
    staticClass: "items",
    attrs: {
      "appear": "appear"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter
    }
  }, _vm._l((_vm.list), function(value, index) {
    return _c('div', {
      key: "index",
      staticClass: "item",
      attrs: {
        "data-index": index
      }
    }, [(value.type === 'time') ? [_c('div', {
      staticClass: "time"
    }, [_c('div', {
      staticClass: "mask"
    }, [_vm._v(_vm._s(value.time))])]), _c('div', {
      staticClass: "descd"
    })] : [_c('div', {
      staticClass: "avatar",
      on: {
        "click": function($event) {
          return _vm.openLink(value.link)
        }
      }
    }, [_c('div', {
      staticClass: "mask"
    }), _c('img', {
      attrs: {
        "src": value.avatar
      }
    }), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(value.name))]), _c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(value.title))])]), _c('div', {
      staticClass: "desc"
    })]], 2)
  }), 0)], 1)])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 506:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slider",
    on: {
      "mouseleave": _vm.play,
      "mouseenter": _vm.pause
    }
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "swiper-slide",
      on: {
        "click": function($event) {
          return _vm.$router.push(("/portfolio?page=1&cat=" + (item.categories) + "&id=" + (item.id)))
        }
      }
    }, [_c('img', {
      staticClass: "img",
      attrs: {
        "src": item.image
      }
    }), _c('div', {
      staticClass: "logo"
    }, [_c('img', {
      attrs: {
        "src": item.logo
      }
    }), _c('div', {
      staticClass: "desc"
    }, [_vm._v(_vm._s(_vm.lang === 'zh' ? item.slogan : item.slogan_en))])])])
  }), 0)])])
},staticRenderFns: []}

/***/ }),

/***/ 507:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timeline"
  }, [_c('div', {
    staticClass: "bg"
  }, [_c('div', {
    staticClass: "bar",
    style: (_vm.barStyle)
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 508:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].contact))]), _c('hr'), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "address"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _c('div', {
    staticClass: "addr"
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].addressBeijing))])]), _vm._m(0)]), _c('div', {
    staticClass: "address"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _c('div', {
    staticClass: "addr"
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].addressShanghai))])]), _vm._m(1)])])]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].follow))]), _c('hr'), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _vm._v(_vm._s(_vm.langs[_vm.lang].bp)), _c('br'), _vm._v("bp@bertelsmann.com")]), _c('div', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _vm._v(_vm._s(_vm.langs[_vm.lang].join)), _c('br'), _vm._v("hr@bertelsmann.com")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _vm._v("+86 10 6563 0026")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _vm._v("+86 21 6418 7585")])
}]}

/***/ }),

/***/ 509:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 510:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact",
    style: ({
      height: _vm.height
    })
  }, [_c('b-header'), _c('div', {
    directives: [{
      name: "fullpage",
      rawName: "v-fullpage",
      value: (_vm.opts),
      expression: "opts"
    }],
    ref: "fullpage",
    staticClass: "container",
    on: {
      "mousewheel": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.mousewheel.apply(null, arguments)
      },
      "wheel": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.mousewheel.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "page",
    style: ({
      height: _vm.height
    })
  }, [_c('div', {
    staticClass: "nav"
  }, [_c('transition', {
    attrs: {
      "name": "left-in"
    }
  }, [(_vm.init) ? _c('div', {
    staticClass: "line"
  }) : _vm._e()]), _c('transition', {
    attrs: {
      "name": "right-in"
    }
  }, [(_vm.init) ? _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].contact))]) : _vm._e()])], 1), _c('div', {
    staticClass: "content"
  }, [_c('transition', {
    on: {
      "enter": _vm.enter,
      "beforeEnter": _vm.beforeEnter
    }
  }, [(_vm.animateCtrl[0]) ? _c('b-footer', {
    staticClass: "footer"
  }) : _vm._e()], 1)], 1), _c('div', {
    staticClass: "copyright"
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].copyright))])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 511:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rightbar"
  }, [_c('div', {
    staticClass: "close iconfont",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("")]), _c('div', {
    staticClass: "menu"
  }, [_c('transition', {
    attrs: {
      "name": "bottom-up",
      "appear": "appear"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].menu))])]), _c('transition-group', {
    attrs: {
      "appear": "appear",
      "tag": "ul"
    },
    on: {
      "before-appear": _vm.beforeEnter,
      "appear": _vm.enter
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('router-link', {
      key: "index",
      attrs: {
        "tag": "li",
        "data-index": index,
        "to": item.link
      }
    }, [_vm._v(_vm._s(item.title[_vm.lang]))])
  }), 1), _c('transition', {
    attrs: {
      "name": "top-in",
      "appear": "appear"
    }
  }, [_c('div', {
    staticClass: "lang"
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.toggleLang('zh')
      }
    }
  }, [_vm._v("中文")]), _vm._v("/"), _c('span', {
    on: {
      "click": function($event) {
        return _vm.toggleLang('en')
      }
    }
  }, [_vm._v("EN")])])])], 1), (_vm.lang === 'zh') ? _c('transition', {
    attrs: {
      "name": "top-in",
      "appear": "appear"
    }
  }, [_c('div', {
    staticClass: "declare"
  }, [_c('b', [_vm._v("【严正声明】")]), _c('p', [_vm._v("近日，我们收到网友举报，有人冒用贝塔斯曼及BAI名义，通过APP、微信群等渠道发布虚假信息，以保本高息产品为诱导，以投资、理财、资本募集等形式开展诈骗活动。这些诈骗行为不仅严重影响了BAI的企业声誉，也造成了相关受众的经济损失。")]), _c('p', [_c('b', [_vm._v("我们在此严正声明：")])]), _c('p', [_vm._v("我公司从未授权任何机构使用“贝塔斯曼”或“BAI”品牌或商标开展任何面向消费者的经营活动。我公司从未开发、运营、冠名过任何APP，且从未授权任何机构开发任何APP，所有网站、应用商店中使用我公司商标、商号、品牌名称的APP均为非法冒用。我公司从未通过组织微信群、QQ群或任何其他渠道公开发布融资信息、组织募资、募捐活动或开展任何诱导消费者投资、缴费入会活动。我公司员工从未以个人名义或以公司名义进行过任何公开融资、募资、募捐或售卖会员资格活动。")]), _c('p', [_vm._v("请公众切勿轻信任何以我公司或我司人员名义发起的融资、募资、募捐、个人投资理财、会员资格购买活动。如遭受损失，我们建议消费者注意保留汇款记录、聊天记录、电话录音等证据，并立即向当地公安机关报案或者登陆网络违法犯罪举报网站举报(网址：http://cyberpolice.mps.gov.cn )。")]), _c('p', [_vm._v("对于冒充贝塔斯曼、BAI或我公司合作机构工作人员的行为，一经核实，我们将追究法律责任。请公众提高警惕，如有任何疑问，请通过以下官方渠道与我们进行预先核实确认：")]), _c('b', [_vm._v("【联络邮箱】")]), _c('li', [_vm._v("bp@bertelsmann.com")]), _c('br'), _c('b', [_vm._v("【官方网站】")]), _c('li', [_c('a', {
    attrs: {
      "href": "http://baifund.com/#/"
    }
  }, [_vm._v("http://baifund.com/#/")])]), _c('br'), _c('b', [_vm._v("【官方微信公众号】")]), _c('li', [_vm._v("bertelsmannchina")])])]) : _c('transition', {
    attrs: {
      "name": "top-in",
      "appear": "appear"
    }
  }, [_c('div', {
    staticClass: "declare"
  }, [_c('b', [_vm._v("【Statement】")]), _c('p', [_vm._v("Recently, BAI (Bertelsmann Asia Investments) received reports that someone has unlawfully used names such as “Bertelsmann Fund” and “Arnold Bahlmann” (hereinafter collectively referred to as \"BAI\") to publish false information through channels including APP, WeChat Group, etc., misleading users with principal-guaranteed and high-interest-bearing products, to conduct fraudulent activities in various form such as investment, wealth management and capital raising. Such fraudulent activities not only severely affected BAI's reputation, but also caused economic losses to investors.")]), _c('p', [_c('b', [_vm._v("BAI hereby solemnly declares:")])]), _c('p', [_vm._v("BAI has never released any APP, nor authorized any entity or individual to conduct any fund-raising activities on behalf of BAI.")]), _c('p', [_vm._v("To avoid unnecessary losses, please do not trust such false information and kindly contact us for confirmation when receiving any such information. If the public encounters such persons or behaviors, please immediately report the case and provide evidence at the local police station to minimize losses and recover funds.")]), _c('p', [_vm._v("Any acts of impersonating the staff of BAI or BAI’s cooperation organization, once verified, will be pursued legal responsibilities. The public is requested to be vigilant. If you have any questions, please confirm with us through the following official channels:")]), _c('b', [_vm._v("【Emails】")]), _c('li', [_vm._v("For BP：bp@bertelsmann.com")]), _c('li', [_vm._v("For career：hr@bertelsmann.com")]), _c('br'), _c('b', [_vm._v("Website")]), _c('li', [_c('a', {
    attrs: {
      "href": "http://baifund.com/#/"
    }
  }, [_vm._v("http://baifund.com/#/")])]), _c('br'), _c('b', [_vm._v("Wechat Account")]), _c('li', [_vm._v("ID：BAI_VC")])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(484)
    },
    on: {
      "click": _vm.toIndex
    }
  }), _c('img', {
    staticClass: "menu",
    attrs: {
      "src": __webpack_require__(486)
    },
    on: {
      "click": _vm.show
    }
  }), _vm._t("default"), _c('transition', {
    attrs: {
      "name": "right-slide"
    }
  }, [(_vm.showRight) ? _c('rightbar', {
    on: {
      "close": _vm.close
    }
  }) : _vm._e()], 1)], 2)
},staticRenderFns: []}

/***/ }),

/***/ 513:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "news",
    style: ({
      height: _vm.height
    })
  }, [_c('b-header'), _c('div', {
    directives: [{
      name: "fullpage",
      rawName: "v-fullpage",
      value: (_vm.opts),
      expression: "opts"
    }],
    ref: "fullpage",
    staticClass: "container",
    on: {
      "mousewheel": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.mousewheel.apply(null, arguments)
      },
      "wheel": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.mousewheel.apply(null, arguments)
      }
    }
  }, [(!_vm.mobi) ? _c('div', {
    staticClass: "page",
    style: ({
      height: _vm.height
    })
  }, [_c('div', {
    staticClass: "nav"
  }, [_c('transition', {
    attrs: {
      "name": "left-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.init),
      expression: "init"
    }],
    staticClass: "line"
  })]), _c('transition', {
    attrs: {
      "name": "right-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.init),
      expression: "init"
    }],
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].news))])])], 1), _c('transition', {
    attrs: {
      "name": "top-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.init),
      expression: "init"
    }],
    staticClass: "detail",
    on: {
      "click": function($event) {
        return _vm.openLink(_vm.newsList[0].link)
      }
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.newsList[0] && _vm.newsList[0].title))]), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.newsList[0] && _vm.newsList[0].content)
    }
  })])])], 1) : _vm._e(), _c('div', {
    staticClass: "page",
    style: ({
      height: _vm.height
    })
  }, [_c('div', {
    staticClass: "bg pc"
  }), _c('div', {
    staticClass: "items"
  }, [_c('transition-group', {
    attrs: {
      "appear": "appear",
      "mode": "out-in"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter
    }
  }, _vm._l((_vm.newsList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item",
      style: ({
        background: ("url(" + (item.img) + ") center / auto 100%")
      }),
      attrs: {
        "data-index": index
      },
      on: {
        "click": function($event) {
          return _vm.openLink(item.link)
        }
      }
    }, [_c('div', {
      staticClass: "mask mask_1"
    }), _c('div', {
      staticClass: "mask"
    }), _c('div', {
      staticClass: "more"
    }, [_vm._v(_vm._s(_vm.langs[_vm.lang].more))]), _c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm._f("time")(item.date)))]), _c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))])])])
  }), 0)], 1), _c('div', {
    staticClass: "morenews pc",
    on: {
      "click": _vm.morenews
    }
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].moreNews))])]), (!_vm.mobi) ? _c('div', {
    staticClass: "page pc",
    style: ({
      height: _vm.height
    })
  }, [_c('div', {
    ref: "iteam",
    staticClass: "newslist",
    on: {
      "mousewheel": function($event) {
        $event.stopPropagation();
        return _vm.moremousewheel.apply(null, arguments)
      }
    }
  }, _vm._l((_vm.oldNewsList), function(item, index) {
    return _c('div', {
      staticClass: "list",
      on: {
        "click": function($event) {
          return _vm.openLink(item.link)
        }
      }
    }, [_c('img', {
      staticClass: "img",
      attrs: {
        "src": item.img
      }
    }), _c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm._f("time")(item.date)))]), _c('span', {
      staticClass: "media"
    }, [_vm._v(_vm._s(item.media))])])])
  }), 0)]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index",
    style: ({
      height: _vm.height
    })
  }, [_c('b-header'), (_vm.currentPage !== 0) ? _c('div', {
    staticClass: "next mobi",
    on: {
      "click": _vm.turnTop
    }
  }, [_vm._v("")]) : _vm._e(), (_vm.currentPage === 0) ? _c('div', {
    staticClass: "next mobi",
    on: {
      "click": _vm.turnNext
    }
  }, [_vm._v("")]) : _vm._e(), _c('div', {
    directives: [{
      name: "fullpage",
      rawName: "v-fullpage",
      value: (_vm.opts),
      expression: "opts"
    }],
    ref: "fullpage",
    staticClass: "container",
    on: {
      "mousewheel": function($event) {
        $event.preventDefault();
        return _vm.mousewheel.apply(null, arguments)
      },
      "wheel": function($event) {
        $event.preventDefault();
        return _vm.mousewheel.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "page page_home",
    style: ({
      height: _vm.height
    })
  }, [_c('transition', {
    attrs: {
      "name": "left-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.animateCtrl[0]),
      expression: "animateCtrl[0]"
    }],
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].bannerTitle1)), _c('br'), _c('div', {
    staticClass: "main"
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].bannerTitle2))])])]), _c('banner', {
    ref: "banner",
    staticClass: "banner",
    attrs: {
      "imgs": _vm.banner
    }
  }), _c('page', {
    ref: "banner_navigation",
    staticClass: "navigation",
    attrs: {
      "total": 3
    },
    on: {
      "prev": _vm.bannerPrev,
      "next": _vm.bannerNext
    }
  }), _c('transition', {
    attrs: {
      "name": "top-in"
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.animateCtrl[0]),
      expression: "animateCtrl[0]"
    }],
    staticClass: "mouse pc",
    attrs: {
      "src": __webpack_require__(487)
    }
  })]), _c('timeline', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentPage === 0),
      expression: "currentPage === 0"
    }],
    ref: "banner_timeline",
    staticClass: "timeline pc",
    attrs: {
      "percent": _vm.indexTime
    },
    on: {
      "reset": _vm.banner_resetTime
    }
  })], 1), _c('div', {
    staticClass: "page page_contact",
    style: ({
      height: _vm.height
    })
  }, [_c('transition', {
    attrs: {
      "name": "left-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.animateCtrl[1]),
      expression: "animateCtrl[1]"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title",
    on: {
      "click": function($event) {
        return _vm.$router.push('/contact')
      }
    }
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].contact))]), _c('transition', {
    attrs: {
      "name": "bottom-in-delay"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.animateCtrl[1]),
      expression: "animateCtrl[1]"
    }],
    staticClass: "template"
  }, [_c('div', {
    staticClass: "city",
    on: {
      "click": function($event) {
        return _vm.switchCity('beijing')
      }
    }
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].beijing))]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isMobi || _vm.showingCity == 'beijing'),
      expression: "isMobi || showingCity == 'beijing'"
    }],
    staticClass: "detail"
  }, [_c('p', [_vm._v("+86 10 6563 0026")]), _c('p', [_vm._v(" " + _vm._s(_vm.langs[_vm.lang].addressBeijing))])]), _c('div', {
    staticClass: "city",
    on: {
      "click": function($event) {
        return _vm.switchCity('shanghai')
      }
    }
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].shanghai))]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isMobi || _vm.showingCity == 'shanghai'),
      expression: "isMobi || showingCity == 'shanghai'"
    }],
    staticClass: "detail"
  }, [_c('p', [_vm._v("+86 21 6418 7585")]), _c('p', [_vm._v(" " + _vm._s(_vm.langs[_vm.lang].addressShanghai))])])])])], 1)]), _c('transition', {
    attrs: {
      "name": "right-in"
    }
  }, [_c('div', {
    attrs: {
      "id": "map"
    }
  })]), _c('a', {
    staticClass: "c2",
    attrs: {
      "href": "http://www.beian.miit.gov.cn"
    }
  }, [_vm._v("京ICP备13001817号-4")]), _c('div', {
    staticClass: "c"
  }, [_vm._v("© 2022贝塔斯曼亚洲投资基金 ALL RIGHTS RESERVED")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 515:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nivagation"
  }, [_c('span', {
    staticClass: "iconfont pre",
    on: {
      "click": _vm.prev
    }
  }, [_vm._v("")]), _c('span', [_vm._v(" " + _vm._s(_vm.current) + " / " + _vm._s(_vm.total))]), _c('span', {
    staticClass: "iconfont next",
    on: {
      "click": _vm.next
    }
  }, [_vm._v(" ")])])
},staticRenderFns: []}

/***/ }),

/***/ 516:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about",
    style: ({
      height: _vm.height
    })
  }, [_c('b-header'), _c('div', {
    directives: [{
      name: "fullpage",
      rawName: "v-fullpage",
      value: (_vm.opts),
      expression: "opts"
    }],
    ref: "fullpage",
    staticClass: "container",
    on: {
      "mousewheel": _vm.mousewheel,
      "wheel": _vm.mousewheel
    }
  }, [_c('div', {
    ref: "about",
    staticClass: "page",
    style: ({
      height: _vm.height,
      overflowY: 'scroll',
      paddingBottom: '20px'
    }),
    on: {
      "mousewheel": function($event) {
        $event.stopPropagation();
        return _vm.mousewheel_about.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "nav"
  }, [_c('transition', {
    attrs: {
      "name": "left-in"
    }
  }, [(_vm.animateCtrl[0]) ? _c('div', {
    staticClass: "line"
  }) : _vm._e()]), _c('transition', {
    attrs: {
      "name": "right-in"
    }
  }, [(_vm.animateCtrl[0]) ? _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].aboutTItle1))]) : _vm._e()]), _c('transition', {
    attrs: {
      "name": "bottom-in-delay"
    }
  }, [(_vm.animateCtrl[0]) ? _c('ul', [_c('li', {
    on: {
      "click": function($event) {
        return _vm.turnToA(0)
      }
    }
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].aboutTItle1))])]) : _vm._e()])], 1), _c('div', {
    staticClass: "page page_about_1"
  }, [_c('div', {
    staticClass: "imgs"
  }, [_c('div', {
    staticClass: "img"
  }), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "mask"
  }, [_c('transition', {
    attrs: {
      "name": "bottom-in"
    }
  }, [(_vm.animateCtrl[0]) ? _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].aboutTItle1))]) : _vm._e()]), _c('transition', {
    attrs: {
      "name": "left-in"
    }
  }, [(_vm.animateCtrl[0]) ? _c('div', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].aboutDetail1))]) : _vm._e()])], 1)])])])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 517:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_vm._l((_vm.imgs), function(value, key) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showPage === key),
        expression: "showPage === key"
      }],
      key: key,
      staticClass: "imgs"
    }, [_c('img', {
      staticClass: "img",
      style: ({
        transform: ("scale(" + _vm.scale + ")")
      }),
      attrs: {
        "src": value.img
      }
    })])
  }), _c('div', {
    staticClass: "mask"
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portfolio",
    style: ({
      height: _vm.height
    })
  }, [_c('b-header', {
    style: ({
      height: _vm.isMobi ? (_vm.currentPage === 1 && _vm.currentCat !== 0 && _vm.currentCat <= 40 ? '180px' : '50px') : '1.5rem',
      backgroundColor: _vm.currentPage !== 1 ? 'transparent' : '#fff'
    })
  }, [(_vm.currentPage !== 0) ? _c('div', {
    staticClass: "sub_nav"
  }, [_c('ul', [_c('li', {
    staticClass: "pc",
    class: {
      selected: _vm.currentPage === 1 && _vm.currentCat === 0
    },
    on: {
      "click": function($event) {
        _vm.setCat(0);
        _vm.turnToA(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].all))]), _c('li', {
    class: {
      selected: _vm.currentPage === 1 && _vm.currentCat !== 0 && _vm.currentCat <= 40
    },
    on: {
      "click": function($event) {
        _vm.setCat(20);
        _vm.turnToA(1)
      }
    }
  }, [_vm._v("BAI")]), _c('li', {
    class: {
      selected: _vm.currentCat === 42
    },
    on: {
      "click": function($event) {
        _vm.setCat(42);
        _vm.turnToA(1)
      }
    }
  }, [_vm._v("FOF")])])]) : _vm._e(), ((_vm.currentPage === 1) && _vm.currentCat !== 0 && _vm.currentCat <= 40) ? _c('div', {
    staticClass: "detail_nav"
  }, [_c('ul', [_c('li', {
    class: {
      selected: _vm.currentCat === 20
    },
    on: {
      "click": function($event) {
        _vm.setCat(20);
        _vm.turnToA(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].Upgrade))]), _c('li', {
    class: {
      selected: _vm.currentCat === 18
    },
    on: {
      "click": function($event) {
        _vm.setCat(18);
        _vm.turnToA(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].Finance))]), _c('li', {
    class: {
      selected: _vm.currentCat === 38
    },
    on: {
      "click": function($event) {
        _vm.setCat(38);
        _vm.turnToA(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].Global))]), _c('li', {
    class: {
      selected: _vm.currentCat === 24
    },
    on: {
      "click": function($event) {
        _vm.setCat(24);
        _vm.turnToA(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].Social))]), _c('li', {
    class: {
      selected: _vm.currentCat === 40
    },
    on: {
      "click": function($event) {
        _vm.setCat(40);
        _vm.turnToA(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].Tech))])])]) : _vm._e()]), _c('div', {
    directives: [{
      name: "fullpage",
      rawName: "v-fullpage",
      value: (_vm.opts),
      expression: "opts"
    }],
    ref: "fullpage",
    staticClass: "container",
    on: {
      "mousewheel": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.mousewheel.apply(null, arguments)
      },
      "wheel": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.mousewheel.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "page first",
    style: ({
      height: _vm.height
    })
  }, [_c('div', {
    staticClass: "nav"
  }, [_c('transition', {
    attrs: {
      "name": "left-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.init),
      expression: "init"
    }],
    staticClass: "line"
  })]), _c('transition', {
    attrs: {
      "name": "right-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.init),
      expression: "init"
    }],
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].portfolio))])]), _c('transition', {
    attrs: {
      "name": "bottom-in-delay"
    }
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.init),
      expression: "init"
    }]
  }, [_c('li', {
    staticClass: "pc",
    on: {
      "click": function($event) {
        _vm.setCat(0);
        _vm.turnToA(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].all))]), _c('li', {
    on: {
      "click": function($event) {
        _vm.setCat(20);
        _vm.turnToA(1)
      }
    }
  }, [_vm._v("BAI")]), _c('li', {
    on: {
      "click": function($event) {
        _vm.setCat(42);
        _vm.turnToA(1)
      }
    }
  }, [_vm._v("FOF")])])])], 1), _c('div', {
    staticClass: "all"
  }, [_c('transition', {
    attrs: {
      "appear": "appear",
      "name": "bottom-in"
    }
  }, [_c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        _vm.setCat(20);
        _vm.turnToA(1)
      }
    }
  }, [_c('div', {
    staticClass: "title",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("BAI")]), _c('div', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].bai))])])]), _c('transition', {
    attrs: {
      "appear": "appear",
      "name": "bottom-in"
    }
  }, [_c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        _vm.setCat(42);
        _vm.turnToA(1)
      }
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("FOF")]), _c('div', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].FOF))])])])], 1)]), _c('div', {
    ref: "protfolioList",
    staticClass: "page",
    style: ({
      height: _vm.height,
      overflowY: 'auto'
    }),
    on: {
      "touchend": _vm.touchend
    }
  }, [_c('div', {
    staticClass: "table",
    style: ({
      marginTop: _vm.isMobi ? (_vm.currentPage === 1) && _vm.currentCat !== 0 && _vm.currentCat <= 40 ? '180px' : '50px' : '1.66667rem'
    }),
    on: {
      "mousewheel": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.wheel.apply(null, arguments)
      },
      "wheel": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.wheel.apply(null, arguments)
      }
    }
  }, [_c('transition-group', {
    attrs: {
      "appear": "appear",
      "mode": "out-in"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter
    }
  }, _vm._l((_vm.currentCatList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item",
      attrs: {
        "data-index": index
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.setCurrent(index)
        },
        "mouseenter": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.mouseEnter(index)
        },
        "mouseleave": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.mouseLeave.apply(null, arguments)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.logo
      }
    }), _c('transition', {
      attrs: {
        "name": "slide",
        "mode": "out-in"
      }
    }, [(_vm.currentLogo == index) ? _c('div', {
      staticClass: "desc pc"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v("PORTFOLIO")]), _c('hr'), _c('p', [_vm._v(_vm._s(_vm.lang === 'zh' ? item.title : item.title_en))])]) : _vm._e()])], 1)
  }), 0)], 1)])]), _c('transition', {
    attrs: {
      "name": "up",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.opend),
      expression: "opend"
    }],
    staticClass: "detail_icon"
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(485)
    }
  }), _c('div', {
    staticClass: "iconfont"
  }, [_vm._v("")])]), _c('div', {
    staticClass: "bg",
    on: {
      "click": function($event) {
        return _vm.openLink(_vm.list[_vm.currentIndex].link)
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "bottom-in"
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.opend),
      expression: "opend"
    }],
    staticClass: "logo",
    attrs: {
      "src": _vm.list[_vm.currentIndex] && _vm.list[_vm.currentIndex].logo
    }
  })]), _c('transition', {
    attrs: {
      "name": "bottom-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.opend),
      expression: "opend"
    }],
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.list[_vm.currentIndex] && (_vm.lang === 'zh' ? _vm.list[_vm.currentIndex].title : _vm.list[_vm.currentIndex].title_en)))])]), _c('transition', {
    attrs: {
      "name": "bottom-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.opend),
      expression: "opend"
    }],
    staticClass: "desc",
    domProps: {
      "innerHTML": _vm._s(_vm.list[_vm.currentIndex] && (_vm.lang === 'zh' ? _vm.list[_vm.currentIndex].content : _vm.list[_vm.currentIndex].content_en))
    }
  })])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(463)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(508),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-35ed2b66",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

},[228]);


// WEBPACK FOOTER //
// static/js/app.47eddf93cde4e2fa05ba.js